import { Pipe, PipeTransform } from '@angular/core';
import { Variant } from '../../../../models/product/dto/variant';
import { Product } from '../../../../models/product/dto/product';
import { Menu } from '../../../../models/menu/dto/menu';
import { PrintCardTheme } from '../../../../models/enum/dto/theme.enum';

@Pipe({
  name: 'getPrintCardOptionTitle',
  standalone: false
})
export class GetPrintCardOptionTitlePipe implements PipeTransform {
  transform(item: Product | Variant, menu: Menu | null): string | null {
    if (item instanceof Product) {
      const getProductTitle = () => {
        return item?.variants?.length === 1 ? item?.variants?.firstOrNull()?.getDisplayName() : item?.getProductTitle();
      };
      const isFikaEdibles = menu?.theme === PrintCardTheme.FikaEdibles;
      const isStiiizyStrain = menu?.theme === PrintCardTheme.StiiizyStrain;
      const isMasterKushStrain = menu?.theme === PrintCardTheme.MasterKushStrain;
      const isStrainCard = isMasterKushStrain || isStiiizyStrain;
      const isChildVariantList = menu?.getSectionsBasedOnMenuType()?.firstOrNull()?.isChildVariantList();
      const multipleFlavours = item?.variants?.length > 1;
      if (isFikaEdibles && isChildVariantList && multipleFlavours) {
        return getProductTitle() + ` (${item?.variants?.length} Flavours)`;
      } else if (isStrainCard && isChildVariantList && multipleFlavours) {
        return getProductTitle() + ` (${item?.variants?.length} Strains)`;
      } else {
        return getProductTitle();
      }
    }
    if (item instanceof Variant) return item?.getVariantTitle();
    return null;
  }
}
